/**
 * String length limits from avrogql Sequelize models / DB columns.
 * Keep in sync with Documents/GitHub/avrogql/models.
 */
export const FIELD_LIMITS = {
    // ticket
    ticket_num: 32,
    airport_code: 9,
    customer_po: 128,
    contact_name: 128,
    contact_email: 64,
    contact_phone: 32,
    // ticket.job_location was dropped; flight_package.job_location is still 128 and the app still edits it
    job_location: 128,

    // ticket_location_item
    location: 255,
    cost_code: 32,

    // ticket_pax
    pax_name: 64,

    // signable
    signatory: 64,
    signatory_job_title: 128,
    signatory_email: 128,
    company: 64,
} as const;
